import { render, staticRenderFns } from "./cotinine-cot-rapid-test.vue?vue&type=template&id=6aae96d4&scoped=true&"
import script from "./cotinine-cot-rapid-test.vue?vue&type=script&lang=js&"
export * from "./cotinine-cot-rapid-test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aae96d4",
  null
  
)

export default component.exports